import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  IOSDubaiTechDataIcon,
  FlutterUKFrameworktIcon,
  FlutterUKToolstIcon,
  FlutterUKLibtIcon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: FlutterUKFrameworktIcon,
    title: "Frameworks",
    description: "Material, Cupertino, MediaQuery, Theme, Localization",
  },
  {
    icon: IOSDubaiTechDataIcon,
    title: "Database",
    description:
      "Sqlite, Firebase realtime database, Firestore, Firebase cloud storage",
  },
  {
    icon: FlutterUKLibtIcon,
    title: "Libraries",
    description:
      "Firebase, Get & provider, Flutter local notifications, Image picker, Dio, Url launcher, Shared preferences",
  },
  {
    icon: FlutterUKToolstIcon,
    title: "Tools & Utilities",
    description:
      "Android Studio, Flutter, Flutter SDK, Intellij idea, Dart plugins, Dart SDK, Version control tools",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>
                Technologies We Use for Flutter Application Development in UK
              </h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              As one of the top-rated Flutter app development companies in UK,
              we use a wide range of powerful technologies and the latest
              frameworks to meet your distinctive business requirements. We use
              Google's Firebase technology to deliver robust backend and data
              services for our Flutter mobile applications. Our Flutter app
              developers utilize a range of tools and technologies for Flutter
              application development to create robust and high-quality mobile
              apps. Some of the key technologies TekRevol employs include:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
